module.exports = __webpack_public_path__ + "img/icon_2_7.2635ed88.png";